<script>
	// import crypto from "crypto";

	import request from "./request.vue";
	import session from "./session.vue";
	import { format } from "date-fns";

	// const hashPassword = (rawPassword) => {
	// 	const staticSalt = "EspressoSalt000";
	// 	let hash = crypto.createHmac('sha256', rawPassword);
	// 	for (var i = 0; i < 1024; i++) {
	// 		hash.update(staticSalt + rawPassword);
	// 	}
	// 	return hash.digest("hex");
	// }

	const adminSchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código do administrador",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "email",
			displayName: "Email",
			kind: "text",
			validation: "required",
			placeholder: "Digite o email",
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "rawPassword",
			displayName: "Senha",
			kind: "password",
			validation: "required",
			creationOnly: true,
		},
	];

	export default {
		create: async function (userInfo) {
			if (userInfo.rawPassword) {
				// userInfo.password = hashPassword(userInfo.rawPassword);
				userInfo.password = userInfo.rawPassword;
			}
			delete userInfo.rawPassword;

			let response = await request.send("user", "createAdmin", userInfo, true);
			return response.data;
		},
		login: async function (email, rawPassword) {
			// let passwordHash = hashPassword(rawPassword);
			let passwordHash = rawPassword;
			let sessionData = await request.send("user", "login", {
				email: email,
				password: passwordHash
			});
			await session.setSessionData(sessionData);
			return sessionData.success;
		},
		logout: async function () {
			try {
				await request.send("user", "logout", {}, true);
			} catch (err) {}

			await session.clear();
		},
		getInfo: async function (id) {
			const response = await request.send("user", "getInfo", { id }, true);
			return response.data;
		},
		updateInfo: async function (userData) {
			const response = await request.send("user", "updateInfo", userData, true);
			return response.data;
		},
		// swipeStatus: async function(technicianId, value) {
		// 	let status = "";

		// 	value ? status = "APPROVED" : status = "SUSPENDED";

		// 	const response = await request.send("user", "updateTechnicianStatus", { technicianId, status }, true);

		// 	return response.success;
		// },
		// importCsv: async function(csv) {
		// 	return request.send("user", "importCsv", { csv }, true);
		// },
		changePassword: async function (userId, newPassword) {
			// let passwordHash = hashPassword(newPassword);
			let passwordHash = newPassword;
			let response = await request.send("user", "changePassword", {
				userId,
				newPassword: passwordHash,
			}, true);
			return response.success;
		},
		remove: async function (id) {
			return request.send("user", "delete", { id }, true);
		},
		search: async function(parameters) {
			const response = await request.send("user", "search", parameters, true);
			return response;
		},
		getSchema: function() {
			return adminSchema;
		},
	}
</script>
